import type { FulfillingMomentName } from './types'

const peacefulnessImage1x =
  'https://assets.riparide.com/fulfilling_moments_images/peacefulness_1x.jpg'
const peacefulnessImage2x =
  'https://assets.riparide.com/fulfilling_moments_images/peacefulness_2x.jpg'
const rejuvinationImage1x =
  'https://assets.riparide.com/fulfilling_moments_images/rejuvination_1x.jpg'
const rejuvinationImage2x =
  'https://assets.riparide.com/fulfilling_moments_images/rejuvination_2x.jpg'
const groundednessImage1x =
  'https://assets.riparide.com/fulfilling_moments_images/groundedness_1x.jpg'
const groundednessImage2x =
  'https://assets.riparide.com/fulfilling_moments_images/groundedness_2x.jpg'
const slownessImage1x =
  'https://assets.riparide.com/fulfilling_moments_images/slowness_1x.jpg'
const slownessImage2x =
  'https://assets.riparide.com/fulfilling_moments_images/slowness_2x.jpg'
const humanConnectionImage1x =
  'https://assets.riparide.com/fulfilling_moments_images/human_connection_1x.jpg'
const humanConnectionImage2x =
  'https://assets.riparide.com/fulfilling_moments_images/human_connection_2x.jpg'
const joyImage1x =
  'https://assets.riparide.com/fulfilling_moments_images/joy_1x.jpg'
const joyImage2x =
  'https://assets.riparide.com/fulfilling_moments_images/joy_2x.jpg'
const unpluggedImage1x =
  'https://assets.riparide.com/fulfilling_moments_images/unplugged_1x.jpg'
const unpluggedImage2x =
  'https://assets.riparide.com/fulfilling_moments_images/unplugged_2x.jpg'
const freedomImage1x =
  'https://assets.riparide.com/fulfilling_moments_images/freedom_1x.jpg'
const freedomImage2x =
  'https://assets.riparide.com/fulfilling_moments_images/freedom_2x.jpg'
const selfDiscoveryImage1x =
  'https://assets.riparide.com/fulfilling_moments_images/self_discovery_1x.jpg'
const selfDiscoveryImage2x =
  'https://assets.riparide.com/fulfilling_moments_images/self_discovery_2x.jpg'
const excitementImage1x =
  'https://assets.riparide.com/fulfilling_moments_images/excitement_1x.jpg'
const excitementImage2x =
  'https://assets.riparide.com/fulfilling_moments_images/excitement_2x.jpg'
const sponteneityImage1x =
  'https://assets.riparide.com/fulfilling_moments_images/sponteneity_1x.jpg'
const sponteneityImage2x =
  'https://assets.riparide.com/fulfilling_moments_images/sponteneity_2x.jpg'
const challengeImage1x =
  'https://assets.riparide.com/fulfilling_moments_images/challenge_1x.jpg'
const challengeImage2x =
  'https://assets.riparide.com/fulfilling_moments_images/challenge_2x.jpg'

const buildImageSrcset = (momentName: FulfillingMomentName) => {
  let image1x = ''
  let image2x = ''

  switch (momentName) {
    case 'peacefulness':
      image1x = peacefulnessImage1x
      image2x = peacefulnessImage2x
      break
    case 'rejuvenation':
      image1x = rejuvinationImage1x
      image2x = rejuvinationImage2x
      break
    case 'groundedness':
      image1x = groundednessImage1x
      image2x = groundednessImage2x
      break
    case 'slowness':
      image1x = slownessImage1x
      image2x = slownessImage2x
      break
    case 'human connection':
      image1x = humanConnectionImage1x
      image2x = humanConnectionImage2x
      break
    case 'joy':
      image1x = joyImage1x
      image2x = joyImage2x
      break
    case 'unplugged':
      image1x = unpluggedImage1x
      image2x = unpluggedImage2x
      break
    case 'freedom':
      image1x = freedomImage1x
      image2x = freedomImage2x
      break
    case 'self-discovery':
      image1x = selfDiscoveryImage1x
      image2x = selfDiscoveryImage2x
      break
    case 'excitement':
      image1x = excitementImage1x
      image2x = excitementImage2x
      break
    case 'spontaneity':
      image1x = sponteneityImage1x
      image2x = sponteneityImage2x
      break
    case 'challenge':
      image1x = challengeImage1x
      image2x = challengeImage2x
      break
    default:
  }

  return `
    ${image1x} 1x,
    ${image2x} 2x
  `
}

export default buildImageSrcset
